module.exports = __webpack_public_path__ + "static/studyHelper-4a52049d5882ac077ce1b1e401814528.jpg";